<template>
  <v-layout>
    <div class="page-banner banner-article">
      <div class="page-banner-mask" />
      <div class="banner-inner">
        <h1><span class="icon-newspaper" />World Recovery Day</h1>
        <p>March 31st, 2019</p>
      </div>
    </div>

    <el-container class="lower-shadow intro-section">
      <el-main class="site-inner">
        <h2>Backup and Recovery</h2>
        <p>What is your plan of action should your data be lost? How long will it take to have your data back up and
          running? How much data will be lost in the process?</p>
        <p>These are terrifying questions that few want to really ask, I know. But these are some of the most important
          questions to ask because, in this digital age, your data can mean your business. March 31st happens to be
          World Recovery Day, so let's take some time to go over some of the ways data can be lost and how we can
          prevent the worst case scenario from happening.</p>
      </el-main>
    </el-container>

    <el-container class="sunken-container web-section lower-shadow">
      <el-main class="sunken-wrapper">
        <el-card class="sunken-inner">
          <div slot="header" class="sunken-header">
            <h2>
              <span class="icon-document-file-html" />The Basics
            </h2>
          </div>
          <div class="sunken-body">
            <h3>Data Loss</h3>
            <p>While it’s possible to print out contracts, invoices, inventory list, and many other items, there are
              many items that just can’t be saved physically to serve the same purpose. Take, for example, your company
              logo. Sure, you have it all over the place, but how many of those copies are anything other than a simple
              .jpeg or .png image? Where is your .eps vector format stored? It can be costly and time-consuming to
              recreate a logo from a small, blurry image file in the event that the original is lost.</p>
            <p>Data loss isn’t simply a computer hard drive crash. Have you ever accidentally deleted a file? Have you
              done so and didn’t realize it was important until some time later? Yes, these are hopefully rare events.
              But so is a hard drive crash. Do you just throw your important files in a Microsoft Onedrive or Google
              Drive and hope they stay secret and safe?</p>
            <h3>Data Thef</h3>
            <p>Ok, you store that company logo on the magical “Cloud” so that it's there forever and can never leave.
              Once it’s on the internet it’s always on the internet, right? That saying is almost as accurate as “What
              happens in Vegas, stays in Vegas”! Cloud storage is nothing more than you putting your files on someone
              else’s hard drive along with a bunch of other people's stuff. And, yes, those hard drives have backups to
              prevent them from losing data should the main drive fail, but it's now out in the public domain.</p>
            <p>This opens up a whole new can of worms as people may not delete your file but they can alter it and you
              may lose the original. They can make it so you can’t get access to it without jumping through hoops and
              red tape. Now you are without any way of getting your files and you’re back at square one.</p>
            <h3>Data Corruption</h3>
            <p>What about CDs, DVDs, and Flash Drives all stored in a fireproof safe? Problem solved? Well, almost
              anyway. Data stored on these mediums breaks down over time and becomes unreadable. Yes, that half-life is
              very long in most cases, but each time you update your files you’re grabbing that physical storage device
              to add to it or update it. This increases the chance for failure and corruption, not to mention the
              hassle of going back and forth with a flash drive to get files when needed on a regular base.</p>
            <h3>What's The Point?</h3>
            <p>Now that I have successfully tin-foiled every way of storing data, what's the point? The point is, no
              ONE method is foolproof. If your company has important documents, you want to make sure that you are
              storing them on secure cloud storage so you have ease of access to them and keep important versions or
              backups located on physical media stored in a safe place. External hard disk drives are great for this
              and so are flash drives. Storing in multiple places can add a few steps to each update you make on these
              important documents and templates, but those small steps will always be better than the long wait if you
              should have to recreate one from scratch.</p>
            <p>So on this World Recovery Day, take some time to make sure that you know and take the necessary steps to
              protect, store, and secure your data. And if you’re not sure what or how to do this, let us know. Ingalls
              Image stands ready to help you with disaster recovery services and consultation. Also, we can redesign
              that logo if you lost the original.</p>
            <hr>
            <div class="author-wrapper">
              <h2>About the Author</h2>
              <el-row :gutter="20">
                <el-col :xs="8" :sm="4" :md="3">
                  <img class="article-author-photo" alt="CEO Geoff Ingalls headshot" src="/articles/authors/geoff-ingalls.jpg">
                </el-col>
                <el-col :xs="16" :sm="20" :md="5" :lg="4">
                  <h3>Geoff Ingalls</h3>
                  <p><strong>CEO & Founder of Ingalls Image</strong></p>
                </el-col>
                <el-col :xs="24" :md="16" :lg="17" class="author-bio">
                  <p>Geoff works closely with the clients of Ingalls Image, sharing his knowledge and experience to
                    help clients succeed. He has spent more than 15 years working with various forms of media and
                    continues today designing, developing, and creating.</p>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-card>
      </el-main>
    </el-container>
    <div class="shadow-bar lower-shadow" />
  </v-layout>
</template>

<style lang="scss" scoped>
 .banner-article {
   background-image:  url('/articles/mar3119/full-banner.jpg');
 }
 .imagery-section {
   background-color: #079246;
  }
 .web-section {
    background-image:  url('/articles/web-bg.jpg'); 
  }
 .conclusion-section {
   background-image:  url('/articles/emailMarketing-3-25-19/conclusion-background.jpg');
  }
</style>


<script>

/* ============
 * Home Index Page
 * ============
 *
 * The home index page.
 */

import VLayout from '@/layouts/Default.vue';

export default {
  /**
   * The name of the page.
   */
  name: 'Mar2519',

  metaInfo: {
    title: 'Ingalls Image', // set a title
    titleTemplate: 'World Recovery Day | Articles | %s', // title is now "My Example App - Yay!"
    htmlAttrs: {
      lang: 'en',
      amp: undefined, // "amp" has no value
    },
    meta: [
      { itemprop: 'name', content: 'World Recovery Day | Articles | Ingalls Image' },
      { property: 'og:title', content: 'World Recovery Day | Articles | Ingalls Image' },
      { itemprop: 'description', content: 'Disaster recovery awareness so you don’t lose what you worked so hard for' },
      { property: 'og:description', content: 'Disaster recovery awareness so you don’t lose what you worked so hard for' },
      { name: 'description', property: 'description', content: 'Disaster recovery awareness so you don’t lose what you worked so hard for' },
      { property: 'og:image', content: 'https://www.ingallsimage.com/articles/mar3119/og-image.jpg' },
      { itemprop: 'image', content: 'https://www.ingallsimage.com/articles/mar3119/og-image.jpg' },
      { property: 'og:url', content: 'https://www.ingallsimage.com/articles/mar3119' },
    ],
    link: [
      { rel: 'canonical', href: 'https://www.ingallsimage.com/articles/mar3119' },
    ],
  },
  /**
   * The components that the page can use.
   */
  components: {
    VLayout,
  },
  data() {
    return {
    };
  },
  mounted() {
    this.$ga.page(this.$router);
  },
  methods: {
    collapseToggle(e) {
      let parent = e.target.parentElement;
      if (parent.nodeName === 'H4') {
        parent = e.target.parentElement.parentElement;
      }
      const grandParent = parent.parentElement;
      const main = parent.nextSibling;
      if (main.style.maxHeight) {
        main.style.maxHeight = null;
        grandParent.classList.remove('collapse-active');
      } else {
        main.style.maxHeight = `${main.scrollHeight}px`;
        grandParent.classList.add('collapse-active');
      }
    },
  },
};
</script>
